import {
  checkReportLikesExportTask,
  checkReportViewsExportTask,
  getPostReportLikes,
  getPostReportViews,
  reportLikesExport,
  reportViewsExport,
} from '../../../../Newsboard.api'

import {
  POST_REPORTS_LIKES_COLUMNS_CONFIG,
  POST_REPORTS_LIKES_TAB,
  POST_REPORTS_VIEWERS_COLUMNS_CONFIG,
  POST_REPORTS_VIEWS_TAB,
} from './NewsboardPostReportsTableModal.constants'

export function getPostReportItemsData(data) {
  return {
    items: data.items.map(item => {
      return { ...item, ...item.owner }
    }),
  }
}

export function getReportTabsConfig(t) {
  return [
    {
      columns: POST_REPORTS_VIEWERS_COLUMNS_CONFIG,
      getItemsFromResponse: getPostReportItemsData,
      id: POST_REPORTS_VIEWS_TAB,
      loadItems: getPostReportViews,
      text: t('Newsboard.ReportsViewsTabKey'),
      onCheckExportTask: checkReportViewsExportTask,
      onStartExport: reportViewsExport,
    },
    {
      columns: POST_REPORTS_LIKES_COLUMNS_CONFIG,
      getItemsFromResponse: getPostReportItemsData,
      id: POST_REPORTS_LIKES_TAB,
      loadItems: getPostReportLikes,
      text: t('Newsboard.ReportsLikesTabKey'),
      onCheckExportTask: checkReportLikesExportTask,
      onStartExport: reportLikesExport,
    },
  ]
}
